import { Link } from "react-router-dom";
import "./button.component.css"

/**
 * Button component
 * @param title title
 * @param to To
 * @param type Button type
 * @param className Further class names
 * @param key Further keys
 * @return Example component
 */
function ButtonComponent(
    props: Readonly<{
        title: string,
        to: string,
        type?: string,
        className?: string,
        [key: string]: any
    }>
) {
    const { title, to, type, className, ...overflowProps } = props;
    
    return (
        <Link className={`button ${type ?? type} ${className ?? ""}`} {...overflowProps} to={to}>
            <p>{title}</p>
        </Link>
    )
}

export default ButtonComponent;